import React from 'react'
import { Auth } from 'aws-amplify'

export const SignOut = () => {
  React.useEffect(() => {
    Auth.signOut()
      .then(() => {
        window.history.replaceState(null, '', '/')
      })
      .catch((e) => {
        console.error('Error signing out:', e)
        window.history.replaceState(null, '', '/')
      })
  }, [])

  return null
}
